import { useEffect, useState } from 'react';
import { useAvailableFeatureCategories } from './queries/useAvailableFeatureCategories';
import { useAvailableFeatures } from './queries/useAvailableFeatures';
import availableFeatureCategoriesService from '../service/availableFeatureCategoriesService';
import useSalesEnablementContext from '../../gqlCommon/hooks/useSalesEnablementContext';
import initWithStockDisabledCategories from '../constants/initWithStockDisabledCategories';
import CategoryLabel from '../enum/CategoryLabel';
import useCustomizeCarContext from './useCustomizeCarContext';
import usePlatformConfig from '../../common/react/usePlatformConfig';

export const useAvailableSections = () => {
  const { selectedCar } = useCustomizeCarContext();
  const { featureSections, featureCategories } = useAvailableFeatureCategories();
  const { features } = useAvailableFeatures();
  const [sections, setSections] = useState([]);
  const { initializedWithStock } = useSalesEnablementContext();
  const {
    platformConfig: { disableInitWithStockDisabledCategories },
  } = usePlatformConfig();
  const displayOffersSection = !!selectedCar?.prices?.totalOfferFeatures?.length;

  useEffect(() => {
    if (!!selectedCar) {
      const allSections = availableFeatureCategoriesService.getFeatureSections(
        featureSections,
        featureCategories,
        features,
      );
      if (initializedWithStock && !disableInitWithStockDisabledCategories) {
        const sections = allSections.filter(
          feature => !initWithStockDisabledCategories.includes(feature.label as CategoryLabel),
        );
        setSections(sections);
      } else {
        setSections(allSections);
      }
    }
  }, [featureSections, featureCategories, features, initializedWithStock]);

  return { featureSections, sections, displayOffersSection };
};
